import React from "react";
import "../../assests/css/students/TopHero.css";

const TopHero = ({ title, description }) => {
  return (
    <section className="th-hero">
      <div className="th-bg"></div>
      <div className="th-overlay"></div>

      <div className="th-content">
        <h2 className="th-title">{title}</h2>
        <p className="th-text">{description}</p>
      </div>
    </section>
  );
};

export default TopHero;
